import validateWithApi from './validateWithApi';
import getValidationFn from './getValidationFn';
import config from './config';

function _validateWithLMT(type, value, errorMessage) {
  return validateWithApi(`${config.url}/${type}`, value, errorMessage);
}

export default function validateWithLMT(type, errorMessage, delay) {
  const validator = (value) => _validateWithLMT(type, value, errorMessage);
  return getValidationFn(validator, errorMessage, delay);
}
